import { Environment, Network, RecordSource, Store } from 'relay-runtime';
import { createFetcher } from 'dibs-relay-network-layer/client';
import SV from 'server-vars';
import qs from 'qs';
import { getBuyerToken } from 'dibs-cookie-jar';

export function getEnvironment() {
    const source = new RecordSource();
    const store = new Store(source);
    const network = Network.create(
        createFetcher({
            getQueries: () => {
                const { shareToken } = qs.parse(window.location.search.replace(/(^\?)/, ''));
                const queries = {
                    ...getBuyerToken(document.cookie),
                    locale: SV.get('locale'),
                };

                if (shareToken) {
                    queries.invoiceAccessToken = shareToken;
                }

                return queries;
            },
        })
    );

    return new Environment({
        network,
        store,
    });
}
